var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurityTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99343 1.48667L3.66677 2.73333C2.9001 3.02 2.27344 3.92667 2.27344 4.74667V9.7C2.27344 10.4867 2.79344 11.52 3.42678 11.9933L6.29344 14.1333C7.23344 14.84 8.78009 14.84 9.72009 14.1333L12.5868 11.9933C13.2201 11.52 13.7401 10.4867 13.7401 9.7V4.74667C13.7401 3.92667 13.1134 3.02 12.3468 2.73333L9.0201 1.48667C8.45343 1.28 7.54676 1.28 6.99343 1.48667Z",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 10.3333C9.47243 10.3333 10.6663 9.13943 10.6663 7.66667C10.6663 6.19391 9.47243 5 7.99967 5C6.52692 5 5.33301 6.19391 5.33301 7.66667C5.33301 9.13943 6.52692 10.3333 7.99967 10.3333Z",
    stroke: "",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16634 6.83333V7.45333C8.16634 7.68667 8.04635 7.90667 7.83968 8.02667L7.33301 8.33333",
    stroke: "",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityTime);
export default __webpack_public_path__ + "static/media/security-time.cf3fbc407d6e3c7a7d2555c9f1377d78.svg";
export { ForwardRef as ReactComponent };